import { cache, sessionCache } from '~/common/useCache'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const refreshToken = cache.get('bus-r-token')
  const cookie = useCookie('user')
  const authStore = useAuthStore()

  if (cookie.value) {
    sessionCache.set('userInfo', cookie.value)
    authStore.userInfo = cookie.value
  }

  // 로그인 페이지로 가는 경우
  if (to.path === '/login') {
    if (refreshToken) {
      return navigateTo('/schedule')
    }
    return
  }

  // 토큰 리다이렉트 페이지는 인증 체크 스킵
  if (to.path.startsWith('/redirect/token')) {
    return
  }

  // 다른 페이지로 가는 경우
  if (!refreshToken) {
    return navigateTo('/login')
  }

  // 루트 경로로 접근하는 경우
  if (to.path === '/' || to.path === '') {
    return navigateTo('/schedule')
  }

  // students 페이지 접근 시 selectedIdx 검증
  if (to.path === '/students') {
    const scheduleStore = useScheduleStore()

    // selectedIdx가 없으면 schedule로 리다이렉트
    if (
      scheduleStore.selectedIdx === '' ||
      scheduleStore.selectedIdx === null ||
      scheduleStore.selectedIdx === undefined
    ) {
      return navigateTo('/schedule')
    }
  }
})
